'use client';
import React from 'react';
import subDays from 'date-fns/subDays';

import Layout from '../lib/components/Layout';
import CalendarService from '../lib/services/CalendarService';
import ColumnsDefinition from './ColumnsDef';
import { formatRequestDate } from '../lib/utils';
import { fetchEconomics } from './Services';

import { ICalendarProps, IDateRange } from '../lib/interfaces';
import { Economics } from '@benzinga/calendar-manager';

export const EconomicsColDef = ColumnsDefinition;
export const fetchEconomicsData = fetchEconomics;

export const EconomicsCalendar: React.FC<ICalendarProps> = ({
  calendar,
  calendarData,
  hasStockTableStyling,
  height,
  initialData,
  initialDateRange,
  leftSlot,
  onReady,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [tableData, setTableData] = React.useState<Economics[]>(initialData || []);
  let dateRange: IDateRange;

  if (initialDateRange) {
    dateRange = initialDateRange;
  } else {
    dateRange = {
      date_from: formatRequestDate(subDays(new Date(), 7)),
      date_to: formatRequestDate(new Date()),
    };
  }

  React.useEffect(() => {
    if (calendarData?.serverSide) {
      setTableData(initialData);
    }
  }, [initialData, calendarData]);

  function onTableReady() {
    if (initialData) {
      setTableData(initialData);
    } else {
      const params = {
        'parameters[date_from]': dateRange.date_from,
        'parameters[date_to]': dateRange.date_to,
      };
      fetchData(params);
    }

    if (onReady) {
      setTimeout(() => onReady());
    }
  }

  function fetchData(filterParams: any) {
    const query = {
      ...filterParams,
      pagesize: 1000,
    };

    setLoading(true);

    const Calendar = new CalendarService();

    Calendar.getEconomics(query)
      .then(({ data }: any) => {
        if (data && data.economics) {
          setTableData(data.economics);
        }
      })
      .finally(() => setLoading(false));
  }

  return (
    <Layout
      calendar={calendar}
      calendarData={calendarData}
      columnDefs={ColumnsDefinition}
      enableSearch={false}
      hasStockTableStyling={hasStockTableStyling}
      height={height}
      initialDateRange={dateRange}
      leftSlot={leftSlot}
      onFilterChanged={fetchData}
      onTableReady={onTableReady}
      tableData={tableData}
      tableLoading={loading}
    />
  );
};
